import { ChatDataPage } from "@interfaces/chat";

interface Raw {
  data: {
    name: string | null;
    total: number;
    values: string[][];
  };
}

export function transformChatPage(raw: unknown): ChatDataPage {
  const data = (raw as Raw).data;

  return {
    name: data.name || "Report",
    total: data.total,
    values: data.values,
  }
}

